// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyTextComponent_container__I6Eqx","successOverlay":"CopyTextComponent_successOverlay__8_ofE","defaultSuccessIcon":"CopyTextComponent_defaultSuccessIcon__0rZW5"};